import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import WidgetCard from "../widget/card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import { Tooltip } from "antd";
import ImgCheckupImpresa from "../../assets/img/checkUp_Impresa.png";
import { TSDIGITAL_PORTALE_PUBLIC_URL } from "../../config.js";
import SimpleLoader from "../general/loader/index";
import { arrayMonths } from "../../constants/shortMonthString";
import { finalAndMoreRatingsColors } from "../../constants/checkup";
import { FormattedMessage } from "react-intl";
import "./widgetCheckup.css";

const WidgetSummaryCheckupImpresa = props => {
  const {
    index,
    title,
    accountantHasCheckupImpresa,    
    inCheckupPage
  } = props;

  const navigate = useNavigate();
  const main = useSelector(state => state.main);
  const checkupSummary = useSelector(state => state.rating.companyCheckupSummary);
  const myType = main.myType;

  const serviceLabelTooltip= <FormattedMessage id="customersWidget.checkupImpresaBanner" />;
  const appName = "creditrisk/details";

  const widgetIndex = {1: "RATING-CREDITIZIO",
    2: "DSCR",
    3: "INDICI-SETTORE"};

  const getFinalAndMoreRatingColor = (finalRating) => {
    return finalAndMoreRatingsColors[finalRating];
  };

  const renderFirstWidget = () => {
    return (Object.keys(checkupSummary?.data).length === 0 ?
      <div className="emptyContent">
        <div className={"placeholder"}>
          <FormattedMessage id="checkup.noRating" />
        </div>
        <div style={{ marginRight: "5px" }}>
          <FontAwesomeIcon
            icon={["far", "cloud-upload"]}
            className="cloudStyle"
          />
        </div>
      </div>
      :
      <div className='cardContainer' style={{flexWrap: "wrap"}}>
        {checkupSummary?.data?.data?.[0]?.MoreScore ?
          <div className='cardContent'>
            <div className='fluidLargeColumn'>&nbsp;</div>
            <div className='fluidSmallColumn'>
              <div className = 'spot' style= {{
                backgroundColor: getFinalAndMoreRatingColor(checkupSummary?.data?.data?.[0]?.MoreScore)
              }}></div>
              <div className='statusText'>{checkupSummary?.data?.data?.[0]?.MoreScore}</div>
            </div>
          </div> : <div className='cardContent'>
            <div className='fluidLargeColumn'>&nbsp;</div>
            <div className='fluidSmallColumn'>
              <div className='statusText'>{"-"}</div>
            </div>
          </div>}
        <div className = 'cardContent textRight'>
          <div className ='statusLabel'><FormattedMessage id="checkup.default1year" /></div>
          <div className='statusValue'>{checkupSummary?.data?.data?.[0]?.PD ? parseFloat(checkupSummary?.data?.data?.[0]?.PD) + "%" : "-"}</div>
        </div>

        {checkupSummary?.data?.data?.[0]?.PN ?
          <div className = 'cardContent textRight'>
            <div className ='statusLabel'><FormattedMessage id="checkup.netAssets" /></div>
            <div className='statusValue' >
              <FontAwesomeIcon
                icon={["fas", checkupSummary?.data?.data?.[0]?.PNAlert === 0 ? "check-circle" : "times-circle"]}
                style={{
                  fontSize: "20px",
                  marginRight: "10px",
                  color: checkupSummary?.data?.data?.[0]?.PNAlert === 0 ? "#74ce77" : "#ab2b37"
                }}
              />{new Intl.NumberFormat("it-IT", {
                style: "decimal",
                currency: "EUR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(parseFloat(checkupSummary?.data?.data?.[0]?.PN)) + " €" }</div>
          </div>
          : <div className = 'cardContent textRight'>
            <div className ='statusLabel'><FormattedMessage id="checkup.netAssets" /></div>
            <div className='statusValue' >{"-"}</div>
          </div>}
      </div>);
  };

  const renderSecondWidget = () => {
    return (Object.keys(checkupSummary?.data).length === 0 ?
      <div className="emptyContent">
        <div className={"placeholder"}>
          <FormattedMessage id="checkup.noDSCR" />
        </div>
        <div style={{ marginRight: "5px" }}>
          <FontAwesomeIcon
            icon={["far", "cloud-upload"]}
            className="cloudStyle"
          />
        </div>
      </div>
      :
      <div className='cardContainer' style={{height: "85px"}}>
        <div className='cardContent textCenterBordered' style={{width: "50%"}}>
          <div className ='statusLabel'>1° <FormattedMessage id="checkup.approach" /></div>
          {checkupSummary?.data?.data?.[0]?.DSCR1 ?
            <div className='fluidLargeColumn'>
              <div style={{display:"inline-block"}}><FontAwesomeIcon
                icon={["fas", checkupSummary?.data?.data?.[0]?.DSCR1Alert === 0 ? "check-circle" : "times-circle"]}
                style={{
                  fontSize: "24px",
                  marginRight: "15px",
                  verticalAlign: "baseline",
                  color: checkupSummary?.data?.data?.[0]?.DSCR1Alert === 0 ? "#74ce77" : "#ab2b37"
                }}
              />
              </div>
              <div className='statusText'>{checkupSummary?.data?.data?.[0]?.DSCR1}</div>
            </div>
            : <div style={{textAlign:"right"}} className='statusText'>{"-"}</div>}
        </div>
        <div className='cardContent' style={{textAlign: "center"}}>
          <div className ='statusLabel'>2° <FormattedMessage id="checkup.approach" /></div>

          {checkupSummary?.data?.data?.[0]?.DSCR2 ?
            <div className='fluidLargeColumn'>
              <div style={{display:"inline-block"}}><FontAwesomeIcon
                icon={["fas", checkupSummary?.data?.data?.[0]?.DSCR2Alert === 0 ? "check-circle" : "times-circle"]}
                style={{
                  fontSize: "24px",
                  marginRight: "15px",
                  verticalAlign: "baseline",
                  color:  checkupSummary?.data?.data?.[0]?.DSCR2Alert === 0 ? "#74ce77" : "#ab2b37"
                }}
              />
              </div>
              <div className='statusText'>{checkupSummary?.data?.data?.[0]?.DSCR2}</div>
            </div>
            : <div style={{textAlign:"right"}} className='statusText'>{"-"}</div>}

        </div>
      </div>
    );
  };

  const renderThirdWidget = () => {
    return (Object.keys(checkupSummary?.data).length === 0 ?
      <div className="emptyContent">
        <div className={"placeholder"}>
          <FormattedMessage id="checkup.noSectorsIndex" />
        </div>
        <div style={{ marginRight: "5px" }}>
          <FontAwesomeIcon
            icon={["far", "cloud-upload"]}
            className="cloudStyle"
          />
        </div>
      </div> :
      <div style={{marginRight: "20px"}}>
        {checkupSummary?.data?.data?.[0]?.CrisiIndiceSostenibilita ?
          <div className='checkupListItem'>
            <div className='checkupListText' style={{width:"85%"}}><FormattedMessage id="checkup.financialSustainability" /></div>
            <div  style={{width:"5%"}}><FontAwesomeIcon
              icon={["fas", checkupSummary?.data?.data?.[0]?.CrisiIndiceSostenibilitaAlert === 0 ? "check-circle" : "times-circle"]}
              style={{
                fontSize: "12px",
                marginRight: "5px",
                verticalAlign: "baseline",
                color: checkupSummary?.data?.data?.[0]?.CrisiIndiceSostenibilitaAlert === 0 ? "#74ce77" : "#ab2b37"
              }}
            /></div>
            <div style={{width:"10px", fontWeight: "bold", color:"#152935"}}>{parseFloat(checkupSummary?.data?.data?.[0]?.CrisiIndiceSostenibilita)}%</div>
          </div> :
          <div className='checkupListItem'>
            <div className='checkupListText' style={{width:"85%"}}><FormattedMessage id="checkup.financialSustainability" /></div>
            <div style={{width:"10px", fontWeight: "bold", color:"#152935"}}>{"-"}</div>
          </div>}
        {checkupSummary?.data?.data?.[0]?.CrisiIndiceAdeguatezza ?
          <div className='checkupListItem'>
            <div className='checkupListText'  style={{width:"85%"}}><FormattedMessage id="checkup.capitalAdequacy" /></div>
            <div  style={{width:"5%"}}><FontAwesomeIcon
              icon={["fas", checkupSummary?.data?.data?.[0]?.CrisiIndiceAdeguatezzaAlert === 0 ? "check-circle" : "times-circle"]}
              style={{
                fontSize: "12px",
                marginRight: "5px",
                verticalAlign: "baseline",
                color: checkupSummary?.data?.data?.[0]?.CrisiIndiceAdeguatezzaAlert === 0 ? "#74ce77" : "#ab2b37"
              }}
            /></div>
            <div  style={{width:"10px", fontWeight: "bold", color:"#152935"}}>{parseFloat(checkupSummary?.data?.data?.[0]?.CrisiIndiceAdeguatezza)}%</div>
          </div>
          :
          <div className='checkupListItem'>
            <div className='checkupListText' style={{width:"85%"}}><FormattedMessage id="checkup.capitalAdequacy" /></div>
            <div style={{width:"10px", fontWeight: "bold", color:"#152935"}}>{"-"}</div>
          </div>}
        {checkupSummary?.data?.data?.[0]?.CrisiIndiceLiquidita ?
          <div className='checkupListItem'>
            <div className='checkupListText'  style={{width:"85%"}}><FormattedMessage id="checkup.liquidity" /></div>
            <div  style={{width:"5%"}}><FontAwesomeIcon
              icon={["fas", checkupSummary?.data?.data?.[0]?.CrisiIndiceLiquiditaAlert === 0 ? "check-circle" : "times-circle"]}
              style={{
                fontSize: "12px",
                marginRight: "5px",
                verticalAlign: "baseline",
                color: checkupSummary?.data?.data?.[0]?.CrisiIndiceLiquiditaAlert === 0 ? "#74ce77" : "#ab2b37"
              }}
            /></div>
            <div  style={{width:"10px", fontWeight: "bold", color:"#152935"}}>{parseFloat(checkupSummary?.data?.data?.[0]?.CrisiIndiceLiquidita)}%</div>
          </div>
          :
          <div className='checkupListItem'>
            <div className='checkupListText' style={{width:"85%"}}><FormattedMessage id="checkup.liquidity" /></div>
            <div style={{width:"10px", fontWeight: "bold", color:"#152935"}}>{"-"}</div>
          </div>}
        {checkupSummary?.data?.data?.[0]?.CrisiIndiceRitorno ?
          <div className='checkupListItem' >
            <div className='checkupListText' style={{width:"85%"}}><FormattedMessage id="checkup.liquidityReturn" /></div>
            <div style={{width:"5%"}}><FontAwesomeIcon
              icon={["fas", checkupSummary?.data?.data?.[0]?.CrisiIndiceRitornoAlert === 0 ? "check-circle" : "times-circle"]}
              style={{
                fontSize: "12px",
                marginRight: "5px",
                verticalAlign: "baseline",
                color: checkupSummary?.data?.data?.[0]?.CrisiIndiceRitornoAlert === 0 ? "#74ce77" : "#ab2b37"
              }}
            /></div>
            <div style={{width:"10px", fontWeight: "bold", color:"#152935"}}>{parseFloat(checkupSummary?.data?.data?.[0]?.CrisiIndiceRitorno)}%</div>
          </div>
          :
          <div className='checkupListItem'>
            <div className='checkupListText' style={{width:"85%"}}><FormattedMessage id="checkup.liquidityReturn" /></div>
            <div style={{width:"10px", fontWeight: "bold", color:"#152935"}}>{"-"}</div>
          </div>}
        {checkupSummary?.data?.data?.[0]?.CrisiIndiceIndebitamento ?
          <div className='checkupListItem'>
            <div className='checkupListText' style={{width:"85%"}}><FormattedMessage id="checkup.socialDebt" /></div>
            <div style={{width:"5%"}}><FontAwesomeIcon
              icon={["fas", checkupSummary?.data?.data?.[0]?.CrisiIndiceIndebitamentoAlert === 0 ? "check-circle" : "times-circle"]}
              style={{
                fontSize: "12px",
                marginRight: "5px",
                verticalAlign: "baseline",
                color: checkupSummary?.data?.data?.[0]?.CrisiIndiceIndebitamentoAlert === 0 ? "#74ce77" : "#ab2b37"
              }}
            /></div>
            <div style={{width:"10px", fontWeight: "bold", color:"#152935"}}>{parseFloat(checkupSummary?.data?.data?.[0]?.CrisiIndiceIndebitamento)}%</div>
          </div>
          :
          <div className='checkupListItem'>
            <div className='checkupListText' style={{width:"85%"}}><FormattedMessage id="checkup.socialDebt" /></div>
            <div style={{width:"10px", fontWeight: "bold", color:"#152935"}}>{"-"}</div>
          </div>}
      </div>);
  };

  let dataToDisplay = null;
  let closingData = checkupSummary?.data?.data?.[0]?.ClosingDate;
  if (closingData) {
    let dateDate = closingData.split("-");
    const stringMonth = arrayMonths[dateDate[1]];
    dataToDisplay = dateDate[2].substring(0, 2) + " " + stringMonth + " " + dateDate[0];
  }

  return (
    <div className={"cardSkeletonSummaryCheckupImpresa noBoxShadow"}>
      <WidgetCard type={`cardSkeletonSummaryCheckupImpresa CheckupBanner ${accountantHasCheckupImpresa || myType==="COMPANY" ? "cardWhite" : ""}`}
        titleWidget={<>{title}{accountantHasCheckupImpresa || myType==="COMPANY" ? <div className='dataSubtitle'>{dataToDisplay}</div> : null}</>}
        customTitle='checkupTitle'
        iconWidget={!accountantHasCheckupImpresa && myType!=="COMPANY" ? <div className='iconWidget'>
          <Tooltip 
            color={"rgb(0, 80, 117)"}
            overlayClassName='tooltipToolsCard' placement="left"
            title={<div className='tooltipContent'>
              <div className='tooltipImage'><img src={ImgCheckupImpresa} alt="ts pay" /></div>
              <div className="labelActiveService tooltip" style={{height:"75px", width:"270px"}}>{serviceLabelTooltip}</div>
              <div style={{textAlign:"right"}}><a href={
                TSDIGITAL_PORTALE_PUBLIC_URL +
                                                                          "#/" +
                                                                          main.accountantIdSelected +
                                                                          "/apps/" + appName
              }
              id="goToTSDigital"
              target="_blank"
              rel="noopener noreferrer"><Button kind='secondary'><FormattedMessage id="actions.discoverMore" /></Button></a></div>
            </div>}>
            <FontAwesomeIcon
              icon={["far", "info-circle"]}
              className="tooltipIcon"
            />
          </Tooltip>
        </div> :

          <div style={{position:"absolute", right: "16px", top:"16px"}}>
            {
              inCheckupPage || Object.keys(checkupSummary?.data).length === 0 ? null :
                checkupSummary.status.started ?
                  <FontAwesomeIcon
                    icon={["far", "circle-notch"]}
                    spin
                    className="tooltipIcon"
                  /> :
                  <FontAwesomeIcon
                    icon={["far", "eye"]}
                    className="tooltipIcon"
                    onClick={() => {
                      if (window.aptrinsic) {
                        if (main.myType === "STUDIO"){
                          window.aptrinsic("track", "digital-box:CHECKUP-SHOW-" + widgetIndex[index] + "-ACCOUNTANT");
                        } else {
                          window.aptrinsic("track", "digital-box:CHECKUP-SHOW-" + widgetIndex[index] + "-COMPANY");
                        }
                      }
                      navigate("/checkup",{state: {index: index}});
                    }}
                  />}
          </div>
        }>
        {!accountantHasCheckupImpresa && myType!=="COMPANY"?
          <>
            <div className = 'lineDraw' style={{width:"68.3%"}}></div>
            <div className = 'lineDraw' style={{width:"87.3%"}}></div>
          </> :
          checkupSummary.status.started ?
            <SimpleLoader></SimpleLoader> :
            <div>
              {index === 1 && renderFirstWidget()}
              {index === 2 && renderSecondWidget()}
              {index === 3 && renderThirdWidget()}
            </div>
        }
      </WidgetCard>
    </div>

  );

};

export default WidgetSummaryCheckupImpresa;
